var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22.4 12C22.4 6.25624 17.7438 1.6 12 1.6C6.25624 1.6 1.6 6.25624 1.6 12C1.6 17.7438 6.25624 22.4 12 22.4C17.7438 22.4 22.4 17.7438 22.4 12ZM11.2 18.2V16.8C11.2 16.3582 11.5582 16 12 16C12.4418 16 12.8 16.3582 12.8 16.8V18.2C12.8 18.6418 12.4418 19 12 19C11.5582 19 11.2 18.6418 11.2 18.2ZM11.2 14.2V5.8C11.2 5.35817 11.5582 5 12 5C12.4418 5 12.8 5.35817 12.8 5.8V14.2C12.8 14.6418 12.4418 15 12 15C11.5582 15 11.2 14.6418 11.2 14.2Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.925fad7b70e1ef0802eb3080ba96d8c4.svg";
export { ForwardRef as ReactComponent };